"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadFileChooser = void 0;

var _StepController = require("../StepController");

var _react = _interopRequireWildcard(require("react"));

var _atoms = require("../../atoms");

var _reactDropzone = require("react-dropzone");

require("./UploadFileChooser.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Vars
var maxVideoSizeMB = 50; // Upload File Chooser

/**
 * Select a local video file via drop zone
 * @param name
 * @param onClose
 * @param onChoose
 * @return {JSX.Element}
 */

var UploadFileChooser = function UploadFileChooser(_ref) {
  var name = _ref.name,
      onClose = _ref.onClose,
      onChoose = _ref.onChoose;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var onDrop = (0, _react.useCallback)(function (acceptedFiles) {
    console.log("Drop Result:", acceptedFiles);

    if (acceptedFiles.length !== 1) {
      setError('Error: multiple files selected');
      return;
    }

    if (!acceptedFiles[0].type.startsWith('video')) {
      setError('Error: only video files are accepted');
      return;
    }

    if (acceptedFiles[0].size > maxVideoSizeMB * 1024 * 1024) {
      setError("Error: File size should be less than ".concat(maxVideoSizeMB, " MB"));
      return;
    }

    setError('');

    if (onChoose) {
      var err = onChoose(acceptedFiles[0]);
      setError(err);
    }
  }, []);

  var _useDropzone = (0, _reactDropzone.useDropzone)({
    onDrop: onDrop
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      isDragActive = _useDropzone.isDragActive;

  return /*#__PURE__*/_react.default.createElement(_StepController.Step, {
    name: name
  }, /*#__PURE__*/_react.default.createElement("div", getRootProps({
    className: "dropzone"
  }), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "dropzone-container",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement("input", getInputProps()), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "dropzone-container-inner"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "dropzone-container-inner-content"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    center: true,
    color: "trace-regular-color",
    bold: isDragActive,
    content: "Drag 'n' drop a video file here, or click to select a file"
  }), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    justifyContent: "center",
    marginTop: "4"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: "small-body",
    bold: true,
    content: "Max size:",
    marginRight: "2"
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: "small-body",
    content: "80 sec and ".concat(maxVideoSizeMB, " MB")
  })), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    color: "error-color",
    content: error,
    marginTop: "4"
  }))))));
};

exports.UploadFileChooser = UploadFileChooser;